import React from 'react';

import { VisuallyHidden } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { IconFacebook, IconInstagram, IconTiktok, IconTwitter, IconYoutube } from './icons';
import { SocialIcon } from './social-icon';
import { SocialIconsContainer } from './styled';
import { ISocialCompProps, ISocialIconsProps } from './types';

const socialComponents = {
  facebookUrl: IconFacebook,
  instagramUrl: IconInstagram,
  tiktokUrl: IconTiktok,
  twitterUrl: IconTwitter,
  youtubeUrl: IconYoutube,
};

const socialIds = {
  facebookUrl: 'followUsOnFacebook',
  instagramUrl: 'followUsOnInstagram',
  tiktokUrl: 'followUsOnTiktok',
  twitterUrl: 'followUsOnTwitter',
  youtubeUrl: 'followUsOnYoutube',
};

export const SocialComp: React.FC<ISocialCompProps> = props => {
  const { formatMessage } = useIntl();
  const SocialComponent = socialComponents[props.item];
  const SocialId = socialIds[props.item];
  return (
    <SocialIcon href={props.href}>
      <VisuallyHidden>{formatMessage({ id: SocialId })}</VisuallyHidden>
      <SocialComponent width={25} aria-hidden="true" />
    </SocialIcon>
  );
};
export const SocialIcons: React.FC<ISocialIconsProps> = props => {
  return (
    <SocialIconsContainer data-testid="social-icons">
      {Object.keys(props).map((item, i) => {
        if (!props[item] || props[item] === '') {
          return null;
        }
        return <SocialComp key={`social_${i}`} item={item} href={props[item]} />;
      })}
    </SocialIconsContainer>
  );
};
